import { animate, style, transition, trigger } from '@angular/animations';

const openActionsTable = trigger('openActionsTable', [
	transition(':enter', [
		style({ transform: 'scaleX(0)', 'transform-origin': 'left' }),
		animate('0.2s ease-in-out', style({ transform: 'scaleX(1)' })),
	]),
	transition(':leave', [
		style({ transform: 'scaleX(1)', 'transform-origin': 'left' }),
		animate('0.2s ease-in-out', style({ transform: 'scaleX(0)' })),
	]),
]);

export default openActionsTable;
